import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import Footer from './footer'
import Header from './header'
import Tabs from './tabs'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'
import Divider from '@material-ui/core/Divider'
import { Animated } from 'react-animated-css'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'
import CookieAdvice from 'containers/CookieAdvice'
import ImageBannerMobile from 'assets/illustrations/kitdigital/banner-m.jpg'
import ImageBenefit1 from 'assets/illustrations/kitdigital/group-68.svg'
import ImageBenefit2 from 'assets/illustrations/kitdigital/group-67.svg'
import ImageBenefit3 from 'assets/illustrations/kitdigital/group-65.svg'
import ImageExternalLogo1 from 'assets/illustrations/kitdigital/logo-gobierno.png'
import ImageExternalLogo2 from 'assets/illustrations/kitdigital/logo-redes.png'
import ImageExternalLogo3 from 'assets/illustrations/kitdigital/logo-kitdigital.png'
import ImageExternalLogo4 from 'assets/illustrations/kitdigital/logo-R.png'
import ImageExternalLogo5 from 'assets/illustrations/kitdigital/logo-ue.png'
import ImageSignature from 'assets/illustrations/kitdigital/signature.svg'
import ArrowDown from 'assets/illustrations/kitdigital/arrow-down.svg'
import ArrowRight from 'assets/illustrations/kitdigital/arrow-right.svg'

const LandingKitDigital = () => {
  const classes = useStyles()

  return (
    <>
      <CookieAdvice />
      <Header />
      <main className={classes.content}>
        <Box pt={8}>
          <Container>
            <Box className={classes.prebanner}>
              <Typography className={classes.prebannerbody3}>
                PROGRAMA KIT DIGITAL COFINANCIADO POR LOS FONDOS NEXT GENERATION
                (EU) DEL MECANISMO DE RECUPERACIÓN Y RESILENCIA
              </Typography>
              <Hidden mdDown>
                <Divider className={classes.prebannerSeparator} />
              </Hidden>
              <Grid container className={classes.prebannerLogosContainer}>
                <Grid item className={classes.prebannerLogos}>
                  <img
                    style={{ maxHeight: '70px', maxWidth: '100%' }}
                    src={ImageExternalLogo1}
                    alt=""
                  />
                  <img
                    style={{ maxHeight: '70px' }}
                    src={ImageExternalLogo2}
                    alt=""
                  />
                  <img
                    style={{ maxHeight: '70px' }}
                    src={ImageExternalLogo3}
                    alt=""
                  />
                  <Box className={classes.prebannerLogoR}>
                    <img
                      style={{ maxHeight: '70px' }}
                      src={ImageExternalLogo4}
                      alt=""
                    />
                  </Box>
                  <img
                    style={{ maxHeight: '70px' }}
                    src={ImageExternalLogo5}
                    alt=""
                  />
                </Grid>
              </Grid>
            </Box>
          </Container>
          <Grid container spacing={4} className={classes.banner}>
            <Container>
              <Grid
                item
                xs={12}
                md={6}
                lg={5}
                className={classes.bannerSecondBlock}
              >
                <Animated animationIn="fadeInRight" animationInDuration={1000}>
                  <Typography variant="h1" className={classes.bannerTitle}>
                    Digitaliza la gestión documental de tu empresa con dokify
                  </Typography>
                </Animated>
                <Animated
                  animationIn="fadeInRight"
                  animationInDuration={1000}
                  animationInDelay={200}
                >
                  <Typography
                    variant="body1"
                    className={classes.bannerSubtitle}
                  >
                    Gestión de procesos
                  </Typography>
                  <Typography
                    variant="body1"
                    className={classes.bannerSubtitle}
                  >
                    Ayudamos a las empresas a ser más eficientes automatizando
                    los requisitos y la gestión documental.
                  </Typography>
                </Animated>
                <Animated
                  animationIn="fadeInUp"
                  animationInDuration={1000}
                  animationInDelay={400}
                >
                  <Button
                    variant="contained"
                    className={classes.bannerButton}
                    href="https://josdokify.typeform.com/to/vnFGsu6K"
                  >
                    ¡Empezamos!
                  </Button>
                </Animated>
              </Grid>
              <Grid item xs={12} md={6} lg={7}>
                <Box textAlign="center">
                  <Hidden mdUp>
                    <img
                      style={{ maxWidth: '380px', width: '100%' }}
                      src={ImageBannerMobile}
                      alt="Digitaliza la gestión documental de tu empresa con dokify"
                    />
                  </Hidden>
                </Box>
              </Grid>
            </Container>
          </Grid>
          <Container>
            <Box pb={4} pt={4}>
              <Grid container>
                <Grid item xs={12}>
                  <Box textAlign="center">
                    <Typography variant="h2" className={classes.featureTitle}>
                      Dokify, tu solución para una gestión de procesos efectiva
                      y eficiente
                    </Typography>
                    <Typography
                      variant="body1"
                      className={classes.featureSubtitle}
                    >
                      Gestiona tus documentos de forma inteligente.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4} className={classes.feature}>
                  <img
                    className={clsx(classes.featureImage)}
                    src={ImageBenefit1}
                    alt="Requisitos"
                  />
                  <Typography className={classes.featureHeading} variant="h2">
                    Requisitos
                  </Typography>
                  <Typography className={classes.featureText} variant="body1">
                    Establecemos todos los requisitos que se pedirán a los
                    proveedores.
                  </Typography>
                </Grid>
                <Hidden smDown>
                  <Divider
                    orientation="vertical"
                    flexItem
                    className={classes.featureDivider}
                  />
                </Hidden>
                <Grid item xs={12} md={4} className={classes.feature}>
                  <img
                    className={clsx(classes.featureImage)}
                    src={ImageBenefit2}
                    alt="Motor inteligente"
                  />
                  <Typography className={classes.featureHeading} variant="h2">
                    Motor inteligente
                  </Typography>
                  <Typography className={classes.featureText} variant="body1">
                    Nuestro motor de requisitos se encarga automáticamente de
                    todo.
                  </Typography>
                </Grid>
                <Hidden smDown>
                  <Divider
                    orientation="vertical"
                    flexItem
                    className={classes.featureDivider}
                  />
                </Hidden>
                <Grid item xs={12} md={4} className={classes.feature}>
                  <img
                    className={clsx(classes.featureImage)}
                    src={ImageBenefit3}
                    alt="Documentos al día"
                  />
                  <Typography className={classes.featureHeading} variant="h2">
                    Documentos al día
                  </Typography>
                  <Typography className={classes.featureText} variant="body1">
                    Todos tus documentos validados y al día de forma eficiente y
                    efectiva.
                  </Typography>
                </Grid>
              </Grid>
              <Divider className={classes.featureDividerHorizontal} />
            </Box>
          </Container>
          <Container>
            <Box pb={7}>
              <Grid container>
                <Grid item xs={12}>
                  <Box textAlign="center">
                    <Typography variant="h2" className={classes.featureTitle}>
                      Conoce nuestros servicios
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Tabs />
          </Container>
          <Container>
            <Box pb={4} pt={8}>
              <Grid container>
                <Grid item xs={12}>
                  <Box textAlign="center">
                    <Typography variant="h2" className={classes.featureTitle}>
                      Dile adiós al papel
                    </Typography>
                    <Typography
                      variant="body1"
                      className={classes.featureSubtitleBold}
                    >
                      Gracias al sistema de firma digital, elimina el papel y
                      firma tus documentos de forma segura y rápida.
                    </Typography>
                    <Box pb={2} pt={4}>
                      <img
                        src={ImageSignature}
                        style={{ maxWidth: '635px', width: '100%' }}
                        alt="Dile adiós al papel"
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
        <Grid container className={classes.sectionDownload}>
          <Container>
            <Box py={2} textAlign="center">
              <Grid container>
                <Hidden xsDown>
                  <Grid item md={1} />
                </Hidden>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="h3"
                    className={classes.sectionDownloadTitle}
                  >
                    ¿Necesitas más información? Te ayudamos.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={1}>
                  <Box textAlign="center" pt={2}>
                    <Hidden mdUp>
                      <img
                        src={ArrowDown}
                        alt="¿Necesitas más información? Te ayudamos."
                      />
                    </Hidden>
                    <Hidden smDown>
                      <img
                        src={ArrowRight}
                        alt="¿Necesitas más información? Te ayudamos."
                      />
                    </Hidden>
                  </Box>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Button
                    variant="contained"
                    className={classes.sectionDownloadButton}
                    href="https://josdokify.typeform.com/to/vnFGsu6K"
                    target="_blank"
                  >
                    Contáctanos
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Grid>
        <Footer />
      </main>
    </>
  )
}

LandingKitDigital.propTypes = {
  open: PropTypes.bool,
}

export default LandingKitDigital
